/**
 * CLICKAR.BIZ INTERNATIONAL REST API
 * APIs Clickar.biz international.
 *
 * OpenAPI spec version: API V1
 * Contact: blureply@reply.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { Injectable, Optional } from "@angular/core";
import { environment } from "@app/../environments/environment";
import { HeaderKey } from "@shared/clickar-constants";
import { VehicleDTO } from "@shared/model/vehicle.model";
import { Configuration } from "@shared/services/utils/configuration";
import { CustomHttpUrlEncodingCodec } from "@shared/services/utils/encoder";
import { Observable } from "rxjs";

@Injectable()
export class FileService {
	protected basePath = "http://localhost:8088";
	defaultHeaders = new HttpHeaders();
	configuration = new Configuration();
	readonly encoderParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });

	constructor(
		protected httpClient: HttpClient,
		@Optional() configuration: Configuration
	) {
		this.basePath = environment.baseApiUrl;

		if (configuration) {
			this.configuration = configuration;
			this.basePath = environment.baseApiUrl || configuration.basePath || this.basePath;
		}
	}

	/**
	 * @param consumes string[] mime-types
	 * @return true: consumes contains "multipart/form-data", false: otherwise
	 */
	/* private canConsumeForm(consumes: string[]): boolean {
		const form = "multipart/form-data";
		for (const consume of consumes) {
			if (form === consume) {
				return true;
			}
		}
		return false;
	} */

	/**
	 * getPdf
	 *
	 * @param idPdf idPdf
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	getPdfUsingGET(idPdf: number, filename: string, observe?: "body", reportProgress?: boolean): Observable<Blob>;
	getPdfUsingGET(idPdf: number, filename: string, observe?: "response", reportProgress?: boolean): Observable<HttpResponse<Blob>>;
	getPdfUsingGET(idPdf: number, filename: string, observe?: "events", reportProgress?: boolean): Observable<HttpEvent<Blob>>;
	getPdfUsingGET(idPdf: number, filename: string, observe: any = "body", reportProgress = false): Observable<any> {
		if (idPdf === null || idPdf === undefined) {
			throw new Error("Required parameter idPdf was null or undefined when calling getPdfUsingGET.");
		}

		let queryParameters = this.encoderParameters;
		if (idPdf !== undefined && idPdf !== null) {
			queryParameters = queryParameters.set("idPdf", <any>idPdf);
		}
		if (filename !== undefined && filename !== null) {
			queryParameters = queryParameters.set("filename", <any>filename);
		}

		const headers = this.defaultHeaders.set("Accept", "application/pdf"),
			requestOptions: any = {
				/* other options here */
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress,
				responseType: "blob"
			};

		return this.httpClient.get<string>(`${this.basePath}/api/v1/secure/pdf`,
			requestOptions
		);
	}

	/**
	 * getGenericFile
	 *
	 * @param idFile idFile
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	getGenericFileUsingGET(idFile: number, observe?: "body", reportProgress?: boolean): Observable<any>;
	getGenericFileUsingGET(idFile: number, observe?: "response", reportProgress?: boolean): Observable<HttpResponse<any>>;
	getGenericFileUsingGET(idFile: number, observe?: "events", reportProgress?: boolean): Observable<HttpEvent<any>>;
	getGenericFileUsingGET(idFile: number, observe: any = "body", reportProgress = false): Observable<any> {
		if (idFile === null || idFile === undefined) {
			throw new Error("Required parameter idFile was null or undefined when calling getGenericFileUsingGET.");
		}

		let queryParameters = this.encoderParameters;
		if (idFile !== undefined && idFile !== null) {
			queryParameters = queryParameters.set("idFile", <any>idFile);
		}

		let headers = this.defaultHeaders;

		// to determine the Accept header
		const httpHeaderAccepts: string[] = ["*/*"],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}

		const requestOptions: any = {
			/* other options here */
			params: queryParameters,
			withCredentials: this.configuration.withCredentials,
			headers,
			observe,
			reportProgress,
			responseType: "blob"
		};

		return this.httpClient.get<string>(`${this.basePath}/api/v1/secure/generic-file`,
			requestOptions
		);
	}

	/**
	 * getImage
	 *
	 * @param idImage idImage
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	getImageUsingGET(idImage: number, observe?: "body", reportProgress?: boolean): Observable<string>;
	getImageUsingGET(idImage: number, observe?: "response", reportProgress?: boolean): Observable<HttpResponse<string>>;
	getImageUsingGET(idImage: number, observe?: "events", reportProgress?: boolean): Observable<HttpEvent<string>>;
	getImageUsingGET(idImage: number, observe: any = "body", reportProgress = false): Observable<any> {
		if (idImage === null || idImage === undefined) {
			throw new Error("Required parameter idImage was null or undefined when calling getImageUsingGET.");
		}

		let queryParameters = this.encoderParameters;
		if (idImage !== undefined && idImage !== null) {
			queryParameters = queryParameters.set("idImage", <any>idImage);
		}

		let headers = this.defaultHeaders;

		// to determine the Accept header

		const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(/* httpHeaderAccepts */["image/jpeg"]);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}

		return this.httpClient.get<string>(`${this.basePath}/api/v1/secure/image`,
			{
				params: queryParameters,
				withCredentials: this.configuration.withCredentials,
				headers,
				observe,
				reportProgress
			}
		);
	}

	/**
	 * uploadFile
	 *
	 * @param file file
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	uploadFileUsingPOST(file: Blob, observe?: "body", reportProgress?: boolean): Observable<any>;
	uploadFileUsingPOST(file: Blob, observe?: "response", reportProgress?: boolean): Observable<HttpResponse<any>>;
	uploadFileUsingPOST(file: Blob, observe?: "events", reportProgress?: boolean): Observable<HttpEvent<any>>;
	uploadFileUsingPOST(file: Blob, observe: any = "body", reportProgress = false): Observable<any> {
		if (file === null || file === undefined) {
			throw new Error("Required parameter file was null or undefined when calling uploadRecDocUsingPOST.");
		}

		let headers = this.defaultHeaders;

		// to determine the Accept header
		const httpHeaderAccepts: string[] = ["*/*"],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}

		headers = headers.set(HeaderKey.NO_SUCCESS_POPUP, "true");

		// to determine the Content-Type header
		// const consumes: string[] = ["multipart/form-data"];

		const formData = new FormData();
		formData.append("file", file);
		return this.httpClient.post<any>(`${this.basePath}/api/v1/secure/file`,
			formData,
			{ headers }
		);
	}

	/**
	 * selectByFile
	 *
	 * @param file file
	 * @param idTemplate idTemplate
	 * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
	 * @param reportProgress flag to report request and response progress.
	 */
	selectByFileUsingPOST(file: Blob, idTemplate: string, observe?: "body", reportProgress?: boolean): Observable<VehicleDTO[]>;
	selectByFileUsingPOST(file: Blob, idTemplate: string, observe?: "response", reportProgress?: boolean): Observable<HttpResponse<VehicleDTO[]>>;
	selectByFileUsingPOST(file: Blob, idTemplate: string, observe?: "events", reportProgress?: boolean): Observable<HttpEvent<VehicleDTO[]>>;
	selectByFileUsingPOST(file: Blob, idTemplate: string, observe: any = "body", reportProgress = false): Observable<any> {
		if (file === null || file === undefined) {
			throw new Error("Required parameter file was null or undefined when calling selectByFileUsingPOST.");
		}

		if (idTemplate === null || idTemplate === undefined) {
			throw new Error("Required parameter idTemplate was null or undefined when calling selectByFileUsingPOST.");
		}

		let headers = this.defaultHeaders;

		// to determine the Accept header
		const httpHeaderAccepts: string[] = ["*/*"],
			httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
		if (httpHeaderAcceptSelected != undefined) {
			headers = headers.set("Accept", httpHeaderAcceptSelected);
		}

		const formData = new FormData();
		formData.append("file", file);
		formData.append("idTemplate", idTemplate);

		return this.httpClient.post<VehicleDTO[]>(`${this.basePath}/api/v1/secure/select-by-file`,
			formData,
			{ headers }
		);
	}
}